<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<script>
import { DEFAULT_TITLE } from '../../../utils/constants';
import { SideBar } from '@/core/config/menu/sideBar';
import { SET_MENU } from '@/core/services/store/modules/menu.module';

export default {
  name: 'ServiceOrder',
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || DEFAULT_TITLE;
        // Sidebar nhóm "Xưởng dịch vụ".
        this.$store.dispatch(SET_MENU, SideBar.SERVICE);
      },
    },
  },
};
</script>
